import { render } from "./supportCard.vue?vue&type=template&id=20af4022&scoped=true&ts=true"
import script from "./supportCard.vue?vue&type=script&lang=ts&config=true"
export * from "./supportCard.vue?vue&type=script&lang=ts&config=true"

import "./supportCard.vue?vue&type=style&index=0&id=20af4022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20af4022"]])

export default __exports__